import React from 'react';
import Blog from '../Blog/Blog';
import Footer from '../Footer/Footer';
import HomeAbout from '../HomeAbout/HomeAbout';
import Portfolio from '../Portfolio/Portfolio';
import Testimonials from '../Testimonials/Testimonials';
import Header from '../Header/Header';

const Home = () => {
    return (
        <>
            <Header></Header>
            <HomeAbout></HomeAbout>
            <Portfolio></Portfolio>
            <Blog></Blog>
            <Testimonials></Testimonials>
        </>
    );
};

export default Home;